import type { PurchaseOrderStatus } from './purchaseTypes';
import { formatMoney } from '../../shared/format/public-api';

export type PurchaseOrderShareInput = {
  status: PurchaseOrderStatus;
  orderNumber: string | null;
  supplierName: string | null;
  total: number;
  items: Array<{
    productName: string | null;
    quantity: number;
    unitCost: number | null;
  }>;
};

/** Visible in `sent` or later. Not on an empty draft. Share does not change status. */
export function canSharePurchaseOrder(status: PurchaseOrderStatus): boolean {
  return status === 'sent' || status === 'partial' || status === 'received' || status === 'closed';
}

function formatShareQty(qty: number): string {
  if (Number.isInteger(qty)) return String(qty);
  return String(qty);
}


export function buildPurchaseOrderShareText(order: PurchaseOrderShareInput): string {
  const header = order.orderNumber?.trim() || 'Orden de compra';
  const supplier = order.supplierName?.trim() || 'Sin proveedor';
  const lines = order.items.map((item) => {
    const qty = Number.isFinite(item.quantity) ? item.quantity : 0;
    const name = item.productName?.trim() || 'Producto';
    if (item.unitCost == null) return `${formatShareQty(qty)} × ${name}`;
    return `${formatShareQty(qty)} × ${name} — ${formatMoney(qty * item.unitCost)}`;
  });
  return [header, supplier, ...lines, `Total: ${formatMoney(order.total)}`].join('\n');
}
